export default "__VITE_ASSET__CN6RnLQ$__"